// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"ee9bae9c","422":"958f0f5b","781":"e35a2e3a","850":"15986acb"}[chunkId] + ".chunk.js";
};